import { Box } from "@mui/material";
import { FlowHubHero } from "./components/FlowHubHero";
import { FlowHubCarousel } from "./components/FlowHubCarousel";
import { Footer } from "../../../../components/Footer";
import { colorsConfig } from "../../../../config/colors.config";
import { FlowHubNavbar } from "./components/FlowHubNavbar";
import { useFlowHubAuth } from "../../hooks/useFlowHubAuth";

export const FlowHubMainLayout = () => {
  const { isLoggedIn, token } = useFlowHubAuth();

  return (
    <Box
      sx={{
        backgroundColor: colorsConfig.background,
        flex: token ? { xs: "0 0 auto", xl: 1 } : "0 0 auto",
        height: token ? { xs: "87dvh", xl: "auto" } : "100dvh",
        minHeight: token ? { xs: "auto", xl: "100%" } : "100dvh",
        width: "100%",
        borderRadius: "14px",
        border: `1px solid ${colorsConfig.border}`,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {!token && <FlowHubNavbar />}
      <FlowHubHero />
      <FlowHubCarousel />
      {!isLoggedIn && <Footer />}
    </Box>
  );
};
